import { useCallback, useEffect, useState } from "react"
import { getHolidays } from "src/redux/api/_hr.api";


interface Holiday {
  date: string;
  occasion: string;
}

export const useFetchHolidays = () => {
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHolidays = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getHolidays();

      if (
        res?.message?.toLowerCase() === "success" &&
        Array.isArray(res?.data?.holidays)
      ) {
        setHolidays(res.data.holidays);
      } else {
        setHolidays([]);
        setError("Invalid holiday data");
      }
    } catch (err) {
      console.error("Failed to fetch holidays:", err);
      setError("Failed to fetch holidays");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHolidays();
  }, [fetchHolidays]);

  return { holidays, loading, error, refetch: fetchHolidays };
}